<div *ngIf="showUserProfile && profile" class="user-profile-card-container d-flex flex-column">
  <div
    class="user-profile-card cursor-pointer d-flex justify-content-start flex-gap-1"
    (click)="currentUserLoginResponse()"
  >
    <div class="identity-icon flex-width-20 d-flex justify-content-center align-items-center">
      <div class="icon-circle"><span class="material-symbols-outlined"> badge </span></div>
    </div>
    <div
      class="profile-data flex-width-80 d-flex flex-column justify-content-center align-items-start"
    >
      <div>
        <span class="head-line-5">{{ profile.fullName }}</span>
      </div>
      <div>
        <span class="font-body-2">{{ profile.user.email }}</span>
      </div>
    </div>
  </div>
  <div class="or-separator m3-label-large">
    {{ 'auth.login.orSeparator' | translate }}
  </div>
  <button
    type="button"
    mat-stroked-button
    color="primary"
    class="button-outline font-button button-register"
    (click)="switchFormOrProfileView()"
  >
    <span class="btn-text">{{ 'auth.button.loginAnotherAccount' | translate }}</span>
  </button>
</div>
<div *ngIf="!showUserProfile" class="login-form-container">
  <form *ngIf="!loading" [formGroup]="loginForm" #f="ngForm" (ngSubmit)="loginUser()">
    <div class="inputs">
      <div class="mat-form-field-container">
        <span class="fake-label m3-label-large">{{ 'login.form.email' | translate }}</span>
        <mat-form-field class="input-full-width">
          <mat-label>{{ 'auth.login.emailPlaceholder' | translate }}</mat-label>
          <input
            matInput
            formControlName="email"
            trim="blur"
            type="text"
            placeholder="{{ 'auth.login.emailPlaceholder' | translate }}"
            appToLowercase
            [readonly]="knownEmail !== undefined"
          />
          <mat-error *ngIf="loginForm.controls.email.hasError('required')">
            {{ 'form.error.fieldRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              loginForm.controls.email.hasError('email') ||
              loginForm.controls.email.hasError('pattern')
            "
          >
            {{ 'form.error.typeEmail' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mat-form-field-container">
        <span class="fake-label m3-label-large">{{ 'login.form.password' | translate }}</span>
        <mat-form-field class="input-full-width">
          <mat-label>{{ 'login.form.placeholders.password' | translate }}</mat-label>
          <input
            matInput
            formControlName="password"
            name="password"
            autocomplete="on"
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="{{ 'login.form.placeholders.password' | translate }}"
          />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="$event.stopPropagation(); hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword"
          >
            <span class="material-symbols-outlined">
              {{ hidePassword ? 'visibility_off' : 'visibility' }}
            </span>
          </button>
          <mat-error *ngIf="loginForm.controls.password.hasError('required')">
            {{ 'form.error.fieldRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="helpers d-flex flex-column justify-content-between flex-gap-1">
      <div class="helper-link m3-label-small cursor-pointer align-self-end">
        <mat-slide-toggle
          #keepSessionOpenSlideToggle
          labelPosition="before"
          color="primary"
          formControlName="persistent"
        >
          <span>{{ 'login.keepSessionOpen' | translate }}</span>
        </mat-slide-toggle>
      </div>
      <div
        class="helper-link m3-label-small cursor-pointer align-self-start"
        [routerLink]="['/auth/forgot-password']"
      >
        {{ 'login.forgotPassword' | translate }}
      </div>
    </div>
    <div class="buttons">
      <button
        type="submit"
        mat-flat-button
        color="primary"
        class="button-primary font-button"
        [disabled]="!loginForm.pristine && !loginForm.valid"
      >
        <span class="material-symbols-outlined icon"> login </span>
        <span class="btn-text">{{ 'auth.button.login' | translate }}</span>
      </button>
    </div>
  </form>
  <div *ngIf="loading" class="custom-bar">
    <app-custom-progressbar
      [progressValue]="progressValue"
      [minValue]="0"
      [maxValue]="100"
      [showStatus]="false"
      [loadingTitle]="'auth.login.loadingTitle' | translate"
    ></app-custom-progressbar>
  </div>
</div>
